import { Asset } from '@/api/generatedApi';
import { DeleteAssetModal } from '@/components/modals/DeleteAssetModal';
import { useGetCurrentUser } from '@/hooks/api/users/useGetCurrentUser';
import { AssetPageObjectModel } from '@/poms/assetPageObjectModel';
import { useTenants } from '@/services/tenants/useTenants';
import DeleteIcon from '@mui/icons-material/DeleteOutlined';
import { Button, IconButton, IconButtonProps, Tooltip } from '@mui/material';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

export const DeleteAssetButton = ({
  asset,
  variant = 'button',
  size = 'small',
  onDelete,
}: {
  asset: Asset;
  variant?: 'button' | 'icon';
  size?: IconButtonProps['size'];
  onDelete?: () => void;
}) => {
  const { permissions } = useGetCurrentUser();
  const navigate = useNavigate();
  const { getPath } = useTenants();

  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);

  const handleDelete = () => {
    setIsDeleteModalOpen(true);
  };

  return (
    <>
      {permissions.canDeleteAssets &&
        (variant === 'button' ? (
          <Button
            onClick={handleDelete}
            startIcon={<DeleteIcon />}
            size={size}
            data-testid={AssetPageObjectModel.DeleteAssetButton}
          >
            Delete
          </Button>
        ) : (
          <Tooltip title='Delete'>
            <IconButton
              onClick={handleDelete}
              size={size}
              color='error'
              data-testid={AssetPageObjectModel.DeleteAssetButton}
            >
              <DeleteIcon sx={{ fontSize: '22px' }} />
            </IconButton>
          </Tooltip>
        ))}
      <DeleteAssetModal
        isOpen={isDeleteModalOpen}
        onClose={() => setIsDeleteModalOpen(false)}
        onDelete={() => (onDelete ? onDelete() : void navigate(getPath('assets')))}
        asset={asset}
      />
    </>
  );
};
